// extracted by mini-css-extract-plugin
export default {"wrapper":"HiddenWrapper_wrapper__VAr8G","wrapper_active":"HiddenWrapper_wrapper_active__U0yLv","visible":"HiddenWrapper_visible__Ipa6o"};